import { render, staticRenderFns } from "./rmHosm.vue?vue&type=template&id=bee7789e"
import script from "./rmHosm.vue?vue&type=script&lang=js"
export * from "./rmHosm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports